import { h } from '@stencil/core';
import cn from 'classnames';
import FontFaceObserver from 'fontfaceobserver';
import { ICON_FONT_NAME, LOAD_TIMEOUT, pesIconSizes } from '@pes-ui/utils';
export class IconComponent {
  constructor() {
    this.handleFontFaceLoaded = () => {
      this.fontLoaded = true;
    };
    this.option = undefined;
    this.size = pesIconSizes.SMALL;
    this.color = undefined;
    this.mirror = undefined;
    this.customStyle = undefined;
    this.fontLoaded = false;
  }
  componentWillLoad() {
    new FontFaceObserver(ICON_FONT_NAME)
      .load(null, LOAD_TIMEOUT)
      .then(this.handleFontFaceLoaded, this.handleFontFaceLoaded);
  }
  render() {
    const iconClass = cn({
      icon: true,
      [`icon--${this.size}`]: true,
      'icon--loaded': this.fontLoaded,
    });
    return (h("span", { class: iconClass }, h("se-icon", { class: "icon__element", option: this.option, size: this.size, color: this.color, mirror: this.mirror, style: this.customStyle }, h("slot", null))));
  }
  static get is() { return "pes-icon"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["icon.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["icon.css"]
    };
  }
  static get properties() {
    return {
      "option": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'button'",
          "resolved": "\"button\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property to define if the icon should act as a button (clickable)."
        },
        "attribute": "option",
        "reflect": false
      },
      "size": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "TIconSize",
          "resolved": "\"large\" | \"medium\" | \"micro\" | \"nano\" | \"small\" | \"xlarge\"",
          "references": {
            "TIconSize": {
              "location": "local",
              "path": "/opt/actions-runner/_work/website-components/website-components/src/components/UI/pes-icon/icon.tsx"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines the size of an icon\n`nano` is 14px\n`micro` is 18px\n`small` is 24px\n`medium` is 32px\n`large` is 52px\n`xlarge` is 62px"
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "pesIconSizes.SMALL"
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'standard' | 'alternative' | 'primary' | 'secondary'",
          "resolved": "\"alternative\" | \"primary\" | \"secondary\" | \"standard\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property that defines the background color of the button.\nThe default color will be inherited from its parent."
        },
        "attribute": "color",
        "reflect": false
      },
      "mirror": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TIconMirror",
          "resolved": "\"both\" | \"horizontal\" | \"vertical\"",
          "references": {
            "TIconMirror": {
              "location": "local",
              "path": "/opt/actions-runner/_work/website-components/website-components/src/components/UI/pes-icon/icon.tsx"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property that defines if the icon should be mirrored."
        },
        "attribute": "mirror",
        "reflect": false
      },
      "customStyle": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property that defines custom style fo icon."
        }
      }
    };
  }
  static get states() {
    return {
      "fontLoaded": {}
    };
  }
  static get elementRef() { return "el"; }
}
